// Third Party
import { NextPage, InferGetServerSidePropsType } from 'next';
import moment from 'moment';

// Utils
import { routes, canonicalUrlForPath } from '@routes';
import {
  SearchProvider,
  getSearchServerSideProps,
} from '@contexts/search-context';

// UI
import { PublicLayout } from '@layouts/public-layout';
import { Search } from '@pages-components/search';
import { MobileSearchModalProvider } from '@components/mobile-search-modal';

export const getServerSideProps = getSearchServerSideProps;

const AccountSearchPage: NextPage<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({
  account,
  cursorAfter,
  cursorBefore,
  features,
  initActiveFeatures,
  initAdultCount,
  initCheckInDate,
  initCheckOutDate,
  initChildCount,
  initInfantCount,
  initMapCoordinates,
  initMapZoom,
  initMinNumberOfBathrooms,
  initMinNumberOfRooms,
  initMinPrice,
  initMaxPrice,
  initPetCount,
  initPropertyTypes,
  initSearchType,
  placeId,
  session,
}) => {
  return (
    <PublicLayout
      session={session}
      loadingSession={false}
      isFooterVisible={false}
      noIndex={true}
      canonicalUrl={canonicalUrlForPath(
        routes.accountListingsSearchShow({ slug: account?.slug! })
      )}
      pageTitle="Search property managers | Savvy"
      pageDescription="Search for property managers on Savvy"
    >
      <MobileSearchModalProvider>
        <SearchProvider
          accountId={account?.id}
          allFeatures={features}
          initActiveFeatures={initActiveFeatures}
          initAdultCount={initAdultCount}
          initCheckInDate={initCheckInDate ? moment(initCheckInDate) : null}
          initCheckOutDate={initCheckOutDate ? moment(initCheckOutDate) : null}
          initChildCount={initChildCount}
          initInfantCount={initInfantCount}
          initMapCoordinates={
            initMapCoordinates ? initMapCoordinates : undefined
          }
          initMapZoom={initMapZoom ? initMapZoom : undefined}
          initMinNumberOfBathrooms={initMinNumberOfBathrooms}
          initMinNumberOfRooms={initMinNumberOfRooms}
          initMinPrice={initMinPrice}
          initMaxPrice={initMaxPrice}
          initPetCount={initPetCount}
          initPropertyTypes={initPropertyTypes}
          initSearchType={initSearchType}
          cursorAfter={cursorAfter}
          cursorBefore={cursorBefore}
          placeId={placeId}
        >
          <Search />
        </SearchProvider>
      </MobileSearchModalProvider>
    </PublicLayout>
  );
};

export default AccountSearchPage;
